export default __webpack_public_path__ + "static/media/soon.5be0c7c7.gif";